export const CountryConstant = {
  CHANGE_COUNTRY: 'CHANGE_COUNTRY'
};
